import * as types from '../mutations'
import LotService from '@/services/LotService'

const state = {
  selectedLot: {},
  lots: [],
  count: 0,
  filteredLots: [],
  loading: true
}

const getters = {
  selectedLot: (state) => state.selectedLot,
  lotList: (state) => state.lots,
  lotCount: (state) => state.count,
  filteredLotList: (state) => state.filteredLots,
  lotLoading: (state) => state.loading,

  getLotsForIngredient: (state) => (ingredient) => {
    return state.lots.filter((lot) => {
      return lot.ingredient.id === ingredient.id
    })
  }
}

const actions = {

  selectLot ({ commit, dispatch }, { lot }) {
    commit(types.SELECT_LOT, lot)
  },

  clearLotSelection ({ commit }) {
    commit(types.CLEAR_LOT_SELECTION)
  },

  async updateLot ({ commit, dispatch }, { lot }) {
    let res = await LotService.updateLot(lot)
    commit(types.LOT_UPDATED, res)
    dispatch('selectLot', { lot })
    return Promise.resolve(res.id)
  },

  async checkLotId ({ commit }, id) {
    try {
      let res = await LotService.checkSlug(id)
      return Promise.resolve(res)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async searchLot ({ commit }, { search, owner }) {
    commit(types.LOT_LOADING)
    let data = await LotService.loadLots(owner, search)
    commit(types.SET_FILTERED_LOT_LIST, data)
    commit(types.LOT_LOADED)
  },

  async loadLotList ({ commit }, { owner }) {
    commit(types.LOT_LOADING)
    let data = await LotService.loadLots(owner)
    commit(types.SET_LOT_LIST, data)
    commit(types.SET_FILTERED_LOT_LIST, data)
    commit(types.LOT_LOADED)
  },

  async createLot ({ commit, dispatch }, { lot }) {
    let res = await LotService.createLot(lot)
    commit(types.LOT_CREATED, res)
    return Promise.resolve(res.id)
  }

}

const mutations = {

  [types.SELECT_LOT] (state, lot) {
    state.selectedLot = lot
  },

  [types.CLEAR_LOT_SELECTION] (state) {
    state.selectedLot = {}
  },

  [types.SET_LOT_LIST] (state, data) {
    state.lots = data.results
  },

  [types.SET_FILTERED_LOT_LIST] (state, data) {
    state.filteredLots = data.results
    state.count = data.count
  },

  [types.LOT_LOADING] (state) {
    state.loading = true
  },

  [types.LOT_LOADED] (state) {
    state.loading = false
  },

  [types.LOT_UPDATED] (state, lot) {
    state.lots = [
      ...state.lots.filter(l => l.id !== lot.id),
      lot
    ]
  },

  [types.LOT_CREATED] (state, lot) {
    state.lots.unshift(lot)
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
